import Methods from '../ApiCalls/apiMethods';
const API_URL = Methods.global_url + '/sanjaya/api.php';
const FORGOT_URL = Methods.global_url + '/sanjaya/auth/forgotpassword.php';
const NOTICE_BOARD_URL = Methods.global_url + '/sanjaya/specialhome.php';

class api {
    constructor() {
        this.body = {};
    }
    method(methodNo) {
        this.body.method = methodNo;
        return this;
    }
    rollNo(rollno) {
        this.body.rollno = rollno;
        return this;
    }
    uuid(rollno) {
        this.body.UUID = rollno;
        return this;
    }
    websanjaya(key) {
        this.body.websanjaya = key;
        return this;
    }
    setMonth(value) {
        this.body.month = value;
        return this;
    }
    setPassword(value) {
        this.body.newpassword = value;
        return this;
    }
    setPhone(value) {
        this.body.phone = value;
        return this;
    }
    setComplaintType(value) {
        this.body.complienttype = value;
        return this;
    }
    setComplaintDesc(value) {
        this.body.complaintdesc = value;
        return this;
    }
    setDesiredGroup(value) {
        this.body.desiredgroup = value;
        return this;
    }
    setReason(value) {
        this.body.reason = value;
        return this;
    }
    setAppointmentDate(value) {
        this.body.appdate = value;
        return this;
    }
    setAppointmentTime(value) {
        this.body.apptime = value;
        return this;
    }

    setAppointmentDescription(value) {
        this.body.appdes = value;
        return this;
    }
    setEventID(value) {
        this.body.eventid = value;
        return this;
    }
    setStatus(value) {
        this.body.status = value;
        return this;
    }
    post() {
        const loginToken = localStorage.getItem('loginToken');
        const body = JSON.stringify(this.body);
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'bearer ' + loginToken
            },
            body
        };
        return fetch(API_URL, requestOptions).then((response) =>
            response.json()
        );
    }
    forgot() {
        const body = JSON.stringify(this.body);
        const requestOptions = {
            method: 'POST',
            body
        };
        return fetch(FORGOT_URL, requestOptions).then((response) =>
            response.json()
        );
    }
    getnoticeboard() {
        const requestOptions = {
            method: 'GET'
        };
        return fetch(NOTICE_BOARD_URL, requestOptions).then((response) =>
            response.text()
        );
    }
}
// .rollNo(rollno) in every post method is deprecated
export function useAPI() {
    const rollno = localStorage.getItem('rollno');
    const getEvents = (month, year) => {
        return new api()
            .method(Methods.EVENTS) 
            .rollNo(rollno)           
            .setMonth(`${month} ${year}`)
            .post();
    };
    const setPassword = (password) => {
        return new api()
            .method(Methods.CHANGEPASSWORD)
            .rollNo(rollno)
            .setPassword(`${password}`)
            .post();
    };
    const submitComplaint = (type, desc) => {
        return new api()
            .method(Methods.SUBMITCOMPLAINT)            
            .setComplaintType(`${type}`)
            .setComplaintDesc(`${desc}`)
            .post();
    };
    const submitGroupChangeRequest =(desiredgroup, reason) => {
        return new api()
            .method(Methods.SUBMITGROUPCHANGE)            
            .setDesiredGroup(`${desiredgroup}`)
            .setReason(`${reason}`)
            .post();
    };
    const submitAppointment = (date,time, desc) => {
        return new api()
            .method(Methods.SUBMITAPPOINTMENT)
            
            .setAppointmentDate(`${date}`)
            .setAppointmentTime(`${time}`)
            .setAppointmentDescription(`${desc}`)
            .post();
    };
    const submitEventParticipation = (eventid, status) => {
        return new api()
            .method(Methods.SUBMITPARTICIPATION)
            .rollNo(rollno)
            .setEventID(`${eventid}`)
            .setStatus(`${status}`)
            .post();
    };
    
    const forgotPassword = (phone, id) => {
        return new api().rollNo(`${id}`).setPhone(`${phone}`).forgot();
    };
    const getDiscipline = () => {
        return new api().method(Methods.DISCIPLINES).post();
    };
    const getHomepagedata = () => {
        return new api().method(Methods.HOMEPAGE).post();
    };
    const getAttendance = () => {
        return new api().method(Methods.ATTENDANCE).post();
    };
    const getNotifications = () => {
        return new api()
            .method(Methods.NOTIFICATIONS)
            .uuid(rollno)
            .websanjaya(true)
            .post();
    };
    const getNotificationsCount = () => {
        return new api()
            .method(Methods.NOTIFICATIONSCOUNT)
            .uuid(rollno)
            .websanjaya(true)
            .post();
    };
    const getTimetable = () => {
        return new api().method(Methods.TIMETABLE).post();
    };
    const getResults = () => {
        return new api().method(Methods.RESULTS).post();
    };
    const getProfile = () => {
        return new api().method(Methods.PROFILE).post();
    };
    const getSonet = () => {
        return new api().method(Methods.SONET).post();
    };
    const getArjuna = () => {
        return new api().method(Methods.ARJUNA).post();
    };
    const getComplaints = () => {
        return new api().method(Methods.GETCOMPLAINTS).post();
    };
    const getAppointments = () => {
        return new api().method(Methods.GETAPPOINTMENTS).post();
    };
    const getStudentDiary = () => {
        return new api().method(Methods.GETSTUDENTDIARY).post();
    };
    
    const complaintType = () => {
        return new api().method(Methods.COMPLAINTTYPE).post();
    };
    const getPerformance = () => {
        return new api().method(Methods.PERFORMANCE).post();
    };
    const getLiveclassroom = () => {
        return new api().method(Methods.LIVECLASSROOM).post();
    };
    const getNoticeBoard = () => {
        return new api().getnoticeboard();
    };

    return {
        getEvents,
        getDiscipline,
        getNotifications,
        getNotificationsCount,
        getNoticeBoard,
        getTimetable,
        getResults,
        getProfile,
        getSonet,
        getArjuna,
        getAttendance,
        getComplaints,
        getAppointments,
        getStudentDiary,
        submitComplaint,
        submitAppointment,
        complaintType,
        getPerformance,
        getLiveclassroom,
        setPassword,
        forgotPassword,
        getHomepagedata,
        submitEventParticipation,
        submitGroupChangeRequest
    };
}
